// Obfuscated WhatsApp contact helper.
// The number and host are stored base64-encoded only and decoded at runtime,
// so no raw number or chat-link string ever appears in the source or DOM.

const _parts = ["OTIzMDA4MjAxMDc0", "d2EubWU=", "KzkyIDMwMCA4MjAgMTA3NA=="];

const _dec = (s) => {
  try {
    if (typeof atob === "function") return atob(s);
    return Buffer.from(s, "base64").toString("binary");
  } catch {
    return "";
  }
};

// Pretty, human-readable number assembled at render time for display.
export const waDisplay = () => _dec(_parts[2]);

// Default greeting so genuine enquiries arrive with a set message.
export const waGreeting = (company) =>
  `Hello ${company || "NBMT Trading Co. FZE LLC"}, I would like to enquire about your products.`;

// Builds the chat link only at click time and opens it. No link is ever
// rendered into an href attribute or the static markup.
export const openWhatsApp = (text) => {
  const num = _dec(_parts[0]);
  const host = _dec(_parts[1]);
  const url =
    "https://" + host + "/" + num + (text ? "?text=" + encodeURIComponent(text) : "");
  if (typeof window !== "undefined") {
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
